import React, { Component } from 'react';
import styled from 'styled-components';
import { localize } from 'react-localize-redux';

const StyledContainer = styled.div`
  height: 100%;
  background-color: #fafafc;
`;

const CenteredContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  -moz-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);

  @media (min-width: 850px) {
    width: 770px;
  }
`;

const StyledImage = styled.img`
  width: 250px;
`;

const RightAlignDiv = styled.div`
  text-align: center;
  @media (min-width: 850px) {
    text-align: left;
    margin-right: 80px;
    display: inline-block;
    vertical-align: top;
  }
`;

const DivContainer = styled.div`
  @media (min-width: 850px) {
    display: inline-block;
    max-width: 436px;
  }

  @media (min-width: 500px) {
    display: inline-block;
    min-width: 436px;
  }
`;

const BoldParagraph = styled.p`
  font-family: Circular-Bold;
  font-size: 17px;
  margin-bottom: 16px;
`;

const StyledLink = styled.a`
  font-family: Circular-Bold;
  font-size: 17px;
  color: #2e00ca;
  display: block;
  margin-top: 8px;
`;

class IncompatibleBrowser extends Component {
  render() {
    return (
      <StyledContainer>
        <CenteredContainer>
          <RightAlignDiv>
            <StyledImage src="/sad_browser.svg" alt="sad" />
          </RightAlignDiv>
          <DivContainer>
            <h2>Oh no! Your current browser is not supported.</h2>
            <BoldParagraph>For the best experience try using Chrome or Firefox!</BoldParagraph>
            <StyledLink href="https://www.google.com/chrome/" target="_blank">
              Install Chrome
            </StyledLink>
            <StyledLink href="https://www.mozilla.org/en-CA/firefox/" target="_blank">
              Install Firefox
            </StyledLink>
          </DivContainer>
        </CenteredContainer>
      </StyledContainer>
    );
  }
}

export default localize()(IncompatibleBrowser);
